module.exports = __webpack_public_path__ + "static/media/session5grayscale.015adfd8.svg";